import React, { useState } from "react";
import { FaEdit, FaSpinner, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { PiPlusBold } from "react-icons/pi";
import { toast } from "react-toastify";

import { fetchVendorSubscriptions, updateVendorSubcription } from "../../../redux/slices/vendorsSlice";

export default function ModalEditVendorSub({ subscription }) {
  const [showModal, setShowModal] = useState(false);
  const status = useSelector(
    (state) => state.vendor?.updateVendorSubscriptionStatus
  );
  const dispatch = useDispatch();

  // Pre-fill form with subscription data (or empty if none passed)
  const initialFormData = {
    name: subscription?.name || "",
    cost: subscription?.cost || "",
    // value: subscription?.value || "",
  };

  const [formData, setFormData] = useState(initialFormData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await dispatch(
        updateVendorSubcription({ id: subscription.id, formData })
      );
      await dispatch(fetchVendorSubscriptions());
      toast.success(res.payload.message);
      // toast.success("Subscription updated successfully");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update subscription");
    }

    setShowModal(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setShowModal(true)}
        className="text-[14px]"
      >
        <FaEdit className="text-lg font-extrabold" />
      </button>

      {showModal && (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none">
            <div className="relative my-6 max-w-lg w-full">
              <div className="border-0 rounded-lg p-6 shadow-lg relative flex flex-col bg-white">
                {/* Close */}
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-2.5 text-gray-400 hover:bg-gray-200 rounded-lg text-sm w-8 h-8 flex items-center justify-center"
                >
                  <FaTimes className="text-gray-300 text-xl" />
                </button>

                {/* Title */}
                <div className="text-center">
                  <h1 className="text-2xl text-gray-800 font-medium mb-4">
                    Update Vendor Subscription
                  </h1>
                </div>

                {/* Form */}
                <div className="flex flex-col gap-4 w-full px-8 py-4">
                  <div>
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      className="pl-[12px] text-[#333843] p-2 rounded-lg text-[14px] bg-[#F9F9FC] w-full border-2 border-[#E0E2E7]"
                    />
                  </div>

                  <div>
                    <label htmlFor="cost">Cost</label>
                    <input
                      type="number"
                      id="cost"
                      name="cost"
                      value={formData.cost}
                      onChange={handleInputChange}
                      required
                      className="pl-[12px] text-[#333843] p-2 rounded-lg text-[14px] bg-[#F9F9FC] w-full border-2 border-[#E0E2E7]"
                    />
                  </div>

                  {/* <div>
                    <label htmlFor="value">Value</label>
                    <input
                      type="text"
                      id="value"
                      name="value"
                      value={formData.value}
                      onChange={handleInputChange}
                      required
                      className="pl-[12px] text-[#333843] p-2 rounded-lg text-[14px] bg-[#F9F9FC] w-full border-2 border-[#E0E2E7]"
                    />
                  </div> */}

                  {/* Buttons */}
                  <div className="flex mt-4 gap-4 justify-center">
                    <button
                      onClick={() => setShowModal(false)}
                      className="text-sm text-blue-500 font-semibold bg-blue-100 py-2 px-4 rounded-lg"
                    >
                      Cancel
                    </button>
                    <button
                      className="flex gap-1 rounded-lg items-center bg-blue-600 text-white py-2 px-4"
                      disabled={status === "loading"}
                      onClick={handleSubmit}
                    >
                      {status === "loading" ? (
                        <>
                          <FaSpinner className="animate-spin" />
                          <p className="text-sm font-semibold whitespace-nowrap">
                            Updating ...
                          </p>
                        </>
                      ) : (
                        <>
                          <PiPlusBold className="w-4 h-4" />
                          <p className="text-sm font-semibold whitespace-nowrap">
                            Update Subscription
                          </p>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      )}
    </>
  );
}
